import {
  CLEAR_ERRORS_CUSTOMERS_ATTACHMENTS,
} from 'pages/Customers/CustomersAttachments/ClearErrorsAttachments/actionTypes';

export const clearErrorsAttachments = (attachments) => (
  { type: CLEAR_ERRORS_CUSTOMERS_ATTACHMENTS, attachments });
